import { withStyles as materialWithStyles } from '@material-ui/core/styles';
import WithStyles, { StyledComponentProps, StyleRules } from '@material-ui/core/styles/withStyles';
export { StyledComponentProps, WithStyles, StyleRules };
export const withStyles = (styles) => (component) => materialWithStyles(styles)(component);
